import axios from 'axios';
import API_CONFIG from '../../config/api.config';
import { getSuperAdminToken } from './superAdminAuthService';

const API_URL = API_CONFIG.BASE_URL;

const superAdminDashboardService = {
  getDashboardStatistics: async () => {
    const token = getSuperAdminToken();
    const response = await axios.get(
      `${API_URL}/superadmin/dashboard/statistics`,
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      }
    );
    return response.data;
  },
};

export default superAdminDashboardService;

